import React, { useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Tooltip,
  Legend
} from "chart.js";

import { Bar, Line, Pie } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Tooltip,
  Legend
);

export default function DashboardCharts(props) {
  const availableYears = [2024, 2025, 2026];

  const [messages, setMessages] = useState([
    { from: "bot", text: "Hi 👋 How can I help you?" }
  ]);
  const [input, setInput] = useState("");

  const orderData = props.orderDetails?.orderDetails;
  const monthlyOrders = orderData?.monthlyOrders;

  const barData = {
    labels: monthlyOrders?.map((item) => item.month),
    datasets: [
      {
        label: "Orders",
        data: monthlyOrders?.map((item) => item.count),
        backgroundColor: "rgba(54, 162, 235, 0.6)"
      }
    ]
  };

  const lineData = {
    labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    datasets: [
      {
        label: "Revenue (€)",
        data: [120, 190, 300, 250, 220, 320, 400],
        borderColor: "rgba(75, 192, 192, 1)",
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        tension: 0.4
      }
    ]
  };

  const pieData = {
    labels: ["Completed", "Failed", "Returned"],
    datasets: [
      {
        data: [orderData?.verified, orderData?.failed, orderData?.returned],
        backgroundColor: ["green", "red", "black"]
      }
    ]
  };

  const commonOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { position: "top" } }
  };

  /* ------------------ CHAT ------------------ */
  const sendMessage = () => {
    if (!input.trim()) return;

    setMessages([
      ...messages,
      { from: "user", text: input },
      { from: "bot", text: "Thanks! Our support team will assist you soon." }
    ]);
    setInput("");
  };

  return (
    <div className="row">
      {/* Row 1 */}
      <div className="col-md-6 mb-4">
        <div className="box">
          <div className="box-header">
            <div
              className="box-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              <h3 className="box-title">Yearly Orders</h3>

              <select
                className="form-control"
                style={{ width: "120px" }}
                value={props.selectedYear}
                onChange={(e) => props.setSelectedYear(Number(e.target.value))}
              >
                {availableYears.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="box-body" style={{ height: "460px" }}>
            <Bar data={barData} options={commonOptions} />
          </div>
        </div>
      </div>

      <div className="col-md-6 mb-4">
        <div className="box">
          <div className="box-header">
            <h3 className="box-title">Weekly Revenue</h3>
          </div>
          <div className="box-body" style={{ height: "500px" }}>
            <Line data={lineData} options={commonOptions} />
          </div>
        </div>
      </div>

      {/* Row 2 */}
      <div className="col-md-6 mb-4">
        <div className="box">
          <div className="box-header">
            <h3 className="box-title">
              Total Order - {orderData?.totalOrders}
            </h3>
          </div>
          <div className="box-body" style={{ height: "300px" }}>
            <Pie data={pieData} options={commonOptions} />
          </div>
        </div>
      </div>

      {/* 🔥 Support Chat – 4th Position */}
      <div className="col-md-6 mb-4">
        <div className="box">
          <div className="box-header">
            <h3 className="box-title">Support Chat</h3>
          </div>

          <div
            className="box-body"
            style={{
              height: "300px",
              display: "flex",
              flexDirection: "column"
            }}
          >
            {/* Messages */}
            <div
              style={{
                flex: 1,
                overflowY: "auto",
                marginBottom: "10px"
              }}
            >
              {messages.map((msg, i) => (
                <div
                  key={i}
                  style={{
                    textAlign: msg.from === "user" ? "right" : "left",
                    marginBottom: "6px"
                  }}
                >
                  <span
                    style={{
                      display: "inline-block",
                      padding: "6px 10px",
                      borderRadius: "12px",
                      background: msg.from === "user" ? "#00c0ef" : "#f1f1f1",
                      color: msg.from === "user" ? "#fff" : "#000"
                    }}
                  >
                    {msg.text}
                  </span>
                </div>
              ))}
            </div>

            {/* Input */}
            <div style={{ display: "flex", gap: "6px" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Type a message..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && sendMessage()}
              />
              <button className="btn btn-primary" onClick={sendMessage}>
                Send
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
